export default "__VITE_ASSET__Am81rczU__"